export const actionTypes = {
  FETCH_USER_REQUEST: 'Request to fetch user profile',
  FETCH_USER_SUCCESS: 'Fetched user profile and saved to state',
  FETCH_USER_FAILURE: 'Failure in fetching user profile',
  SET_REDIRECT_PATH: 'Set redirect path',
};
